import React, {useState} from 'react';
import {Link, useNavigate, useLocation} from 'react-router-dom';
import classes from './Navbar.module.scss';
import icon from '../Images/icon.svg';
import {GiHamburgerMenu} from 'react-icons/gi';
import {IoMdClose} from 'react-icons/io';

function Navbar() {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation(); // Get current route path

    const getLinkClass = (path) => {
        return location.pathname === path ? classes['active-link'] : '';
    };

    return (
        <div className={classes['navbar']}>
            <div className={classes['navbar-section']}>
                <img src={icon} className={classes['icon']} onClick={() => navigate('/')}/>

                <div className={classes['burger']} onClick={() => setIsOpen(!isOpen)}>
                    {isOpen ? <IoMdClose size={32}/> : <GiHamburgerMenu size={32}/>}
                </div>

                <ul className={`${classes['navbar-items']} ${isOpen ? classes['open'] : ''}`}>
                    <li><Link to="/" className={getLinkClass('/')}>Home</Link></li>
                    <li><Link to="/uav" className={getLinkClass('/uav')}>UAV</Link></li>
                    <li><Link to="/project" className={getLinkClass('/project')}>Projects</Link></li>
                    <li><Link to="/news" className={getLinkClass('/news')}>News</Link></li>
                    <li><Link to="/aboute" className={getLinkClass('/aboute')}>About us</Link></li>
                    <li><Link to="/contact" className={getLinkClass('/contact')}>Contact</Link></li>
                </ul>
            </div>
        </div>
    );
}

export default Navbar;
